import { render, staticRenderFns } from "./obs-department-question.vue?vue&type=template&id=7cf914b5&"
import script from "./obs-department-question.vue?vue&type=script&lang=js&"
export * from "./obs-department-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports